<template>
     <vs-dialog v-model="active" prevent-close width="700px">
        <template #header>
          <h4 class="not-margin">
            Agregar <b>Códigos de sesión</b>
          </h4>
        </template>
        <div class="center content-inputs">
            <vs-row>
                <vs-col vs-type="flex" vs-justify="center" vs-align="left" w="4" > 
                    <vs-select filter label-placeholder="Ciclo Escolar" v-model="cicloEscolar" disabled >
                        <template #message-danger v-if="errorFields.includes('edificio')">
                            Requerido
                        </template>
                        <template v-if="listCiclos.length">
                            <vs-option v-for="option in listCiclos" :key="option.id"  :label="option.text" :value="option.id">
                                {{option.text}}
                            </vs-option>
                        </template>
                        <template v-else>
                            <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                            </vs-option>
                        </template>
                    </vs-select>
                </vs-col>
                <vs-col vs-type="flex" vs-justify="center" vs-align="left" w="4" >
                    <vs-select filter label-placeholder="Nivel Academico" v-model="nivelAcademico" disabled @input="listarProgramas" >
                        <template #message-danger v-if="errorFields.includes('docenteAuxiliar')">
                            Requerido
                        </template>
                        <template v-if="listNiveles.length">
                            <vs-option v-for="option in listNiveles" :key="option.id"  :label="option.text" :value="option.id">
                                {{option.text}}
                            </vs-option>
                        </template>
                        <template v-else>
                            <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                            </vs-option>
                        </template>
                        
                    </vs-select>                       
                </vs-col>
                <vs-col vs-type="flex" vs-justify="center" vs-align="left" w="4" >
                     <vs-select filter label-placeholder="Programas" v-model="programa" disabled :key="programaId" >
                        <template #message-danger v-if="errorFields.includes('aula')">
                            Requerido
                        </template>
                        <template v-if="listProgramas.length">
                            <vs-option v-for="option in listProgramas" :key="option.id"  :label="option.text" :value="option.id">
                                {{option.text}}
                            </vs-option>
                        </template>
                        <template v-else>
                            <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                            </vs-option>
                        </template>
                    </vs-select>
                </vs-col>
                <vs-col vs-type="flex" vs-justify="center" vs-align="left" w="4" > 
                    <vs-select filter label-placeholder="Grado" v-model="grado" :key="gradosId" disabled>
                        <template v-if="listGrados.length">
                            <vs-option v-for="option in listGrados" :key="option.id" :label="option.text" :value="option.id">
                                {{option.text}}
                            </vs-option>
                        </template>
                        <template v-else>
                            <vs-option label="No hay datos" v-text="'No hay datos'" :value="0">
                            </vs-option>
                        </template>
                    </vs-select>
                </vs-col>
            </vs-row>
            <vs-row>
                <vs-col vs-type="flex" vs-justify="center" vs-align="left" w="12" > 
                    <table-crns v-model="selected" :crns="crns" :institucion="institucion" :cicloEscolar="cicloEscolar" :nivelAcademico="nivelAcademico" :programa="programa" :rowData="rowData" :grado="grado"></table-crns>
                </vs-col>
            </vs-row>
        </div>
        <template #footer>
            <div class="footer-dialog">
                <div class="con-footer">
                    <vs-button v-if="rowData && rowData.registros_academicos_vinculados == 0" center @click="saveform()">
                        Guardar
                    </vs-button>
                </div>

                <div class="new">
                    Dudas? <a href="#">Ve el tutorial de esta sección</a>
                </div>
            </div>
        </template>
    </vs-dialog>
</template>

<script>
import catalogos from '../../../../api/requests/catalogos.js'
import bloques from '../../../../api/requests/bloques.js'
import TableCrns from '../tables/crns'
export default {
    props:[
        'rowData',
        'value',
        'listNiveles',
        'listCiclos',
        'institucion',
    ],
    data () {
        return {
            cicloEscolar: '',
            nivelAcademico: '',
            programa: '',
            listProgramas: [],
            selected: [],
            active: false,
            programaId: (new Date()).getTime(),
            errorFields: [],
            errorTime: '',
            crns: [],
            grado:'',
            listGrados: [],
            gradosId: (new Date()).getTime(),
        }
    },
    methods: {
        async listarProgramas (nivelAcademico = null) {
            nivelAcademico = nivelAcademico || this.nivelAcademico || 0  
            if (nivelAcademico){
                try {
                    const { data: programas } = await catalogos.getProgramasByNivel(this.institucion, nivelAcademico)
                    this.programa = ''
                    this.listProgramas = programas
                    this.programaId = (new Date()).getTime()
                } catch (error) {
                        
                }
            }else {
                this.listProgramas = []
            }
        },
        async getGrado (programa) { 
            if (programa){
                try {
                    this.loadingSelect = true
                    const { data: response } = await catalogos.getGrado(programa)
                    this.grado = ''
                    this.listGrados = response
                    this.gradosId = (new Date()).getTime()
                    this.loadingSelect = false
                } catch (error) {
                        
                }
            }else {
                this.listGrados = []
            }
        },
        async fillForm(row){
            this.rowId = row.id || null
            this.cicloEscolar = row.ciclo_escolar_id || ''
            this.nivelAcademico = row.nivel_academico_id || ''
            this.nombre = row.nombre || ''
            this.crns = row.crns || []
            await this.listarProgramas(row.nivel_academico_id)
            this.programa = row.programa_id || ''
            await this.getGrado(this.programa)
            this.grado = row.grado_id
        },
        async saveform() {
            try {
                const payload = {
                    ids: this.selected.map(e=>e.id)
                }
                if (payload) {
                    await bloques.updateDetail(this.rowId, payload)
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'success',
                        position: null,
                        title: 'Exito',
                        text: `Registro guardado`
                    })
                    this.$emit('refreshTable',true)
                    this.active = false
                }
            } catch (error) {
                if ( error && error.response && error.response.data && error.response.data.errors){
                    const data = error.response.data.errors
                    data.forEach(element => {
                        this.$vs.notification({
                            progress: 'auto',
                            color: 'danger',
                            position: null,
                            title: 'Error',
                            text: element
                        })
                    });

                }else{
                    this.$vs.notification({
                            progress: 'auto',
                            color: 'danger',
                            position: null,
                            title: 'Error',
                            text: `Algo salió mal`
                    })
                }
            }
        }
    },
    components: {
        TableCrns
    },
    watch: {
        value (val) {
            this.active = val
        },
        active (val) {
            if (!val){
                this.$emit('input', val);
            }
        },        
        rowData (val) {
            if (val instanceof Object){
                this.fillForm(val)
            }
        },

    }
}
</script>
<style scoped>
    .con-footer {
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }
    .con-footer .vs-button .vs-button__content {
        padding: 10px 30px;
    }
    .con-footer .vs-button {
        margin: 0;
    }
</style>